var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pr-header',{staticClass:"d-print-none"}),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('pr-scope-tree',{attrs:{"scopeFullPath":true}}),_c('div',{staticClass:"center-container"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }